module.exports = __webpack_public_path__ + "img/iconCircleArrowWhite.8f150da1.svg";